import { PlatformKpis, PlatformTenant } from "./types";

/**
 * Zbrojevi kroz sve klijente.
 *
 * Nema izračuna naplate iz paketa — raniji `computeTenantBilling` je množio hardkodirane
 * cijene paketa u pregledniku. Cijene sada dolaze iz cjenika kroz resolver, pa se ovdje samo
 * zbraja ono što je backend već razriješio.
 */
export const computeKpis = (tenants: PlatformTenant[]): PlatformKpis => ({
  tenantsTotal: tenants.length,
  vehiclesTotal: tenants.reduce((sum, t) => sum + t.vehicleCount, 0),
  vehiclesPublished: tenants.reduce((sum, t) => sum + t.publishedVehicleCount, 0),
  vehiclesDraft: tenants.reduce((sum, t) => sum + t.draftVehicleCount, 0),
  usersTotal: tenants.reduce((sum, t) => sum + t.userCount, 0),
  invoicesOutgoing: tenants.reduce((sum, t) => sum + t.outgoingInvoiceCount, 0),
  invoicesIncoming: tenants.reduce((sum, t) => sum + t.incomingInvoiceCount, 0),
  minimumMonthlyTotal: tenants.reduce((sum, t) => sum + (t.minimumMonthly ?? 0), 0),
  tenantsOnScheme: tenants.filter((t) => t.pricingSchemeName !== null).length,
});
